// extracted by mini-css-extract-plugin
export default {"container":"VnIfG6aJlzXad9ZWWy8r","sellingContainer":"GWmV3PKpalx2HlqKtoFn"};